export const USER_ROLES = {
  ADMIN: 0,
  MEDIA_BUYER: 1,
  AFFILIATE: 2,
  CONTENT_MEDIA_MANAGER: 3,
  AFFILIATE_MANAGER: 4,
  MEDIA_MANAGER: 5,
};
